import dayjs from 'dayjs';

export const getDateWithFallback = (
  value: string | null,
  fallback = '-'
): Date | string => {
  if (!value) {
    return fallback;
  }

  const date = dayjs(value);

  return date.isValid() ? date.toDate() : fallback;
};
